import React from 'react';

/** Filter values keyed by the list API parameter they are sent as; 'all' / '' means unfiltered. */
export const NO_SESSION_FILTERS = {
  status: 'all',
  report_status: 'all',
  published_wordpress: 'all',
  published_faicon: 'all',
  event_id: 'all',
  user: 'all',
  model: 'all',
  date_from: '',
  date_to: '',
};

const PUBLISHED_OPTIONS = [['all', 'Any'], ['yes', 'Published'], ['no', 'Not published']];
const REPORT_OPTIONS = [['all', 'Any'], ['complete', 'Complete'], ['in_progress', 'In progress'], ['none', 'No report']];

const FilterSelect = ({ label, value, onChange, options }) => (
  <label>
    <span>{label}</span>
    <select value={value} onChange={(event) => onChange(event.target.value)}>
      {options.map(([optionValue, optionLabel]) => (
        <option key={optionValue} value={optionValue}>{optionLabel}</option>
      ))}
    </select>
  </label>
);

const DateInput = ({ label, value, onChange }) => (
  <label>
    <span>{label}</span>
    <input type="date" value={value} onChange={(event) => onChange(event.target.value)} />
  </label>
);

const FilterSection = ({ title, single = false, children }) => (
  <div className="sessions-popover-section">
    <p className="sessions-popover-section-title">{title}</p>
    <div className={`sessions-popover-grid${single ? ' sessions-popover-grid-single' : ''}`}>{children}</div>
  </div>
);

const withAnyOption = (anyLabel, values) => [['all', anyLabel], ...values.map((value) => [value, value])];

/**
 * Popover body. `facets` holds the transcript statuses, `[id, title]` event pairs,
 * user names and model names that exist in the data.
 */
const SessionFilters = ({ filters, setFilter, facets }) => {
  const filterBy = (name) => (value) => setFilter(name, value);
  const statusOptions = [['all', 'Any'], ...facets.statuses.map((status) => [status, status.replaceAll('_', ' ')])];
  const hasContext = facets.events.length > 0 || facets.users.length > 0 || facets.models.length > 0;

  return (
    <>
      <FilterSection title="Workflow">
        <FilterSelect label="Transcript" value={filters.status} onChange={filterBy('status')} options={statusOptions} />
        <FilterSelect label="Report" value={filters.report_status} onChange={filterBy('report_status')} options={REPORT_OPTIONS} />
      </FilterSection>

      <FilterSection title="Publishing">
        <FilterSelect label="WordPress" value={filters.published_wordpress} onChange={filterBy('published_wordpress')} options={PUBLISHED_OPTIONS} />
        <FilterSelect label="Faicon" value={filters.published_faicon} onChange={filterBy('published_faicon')} options={PUBLISHED_OPTIONS} />
      </FilterSection>

      {hasContext && (
        <FilterSection title="Context" single>
          {facets.events.length > 0 && (
            <FilterSelect label="Event" value={filters.event_id} onChange={filterBy('event_id')} options={[['all', 'Any event'], ...facets.events]} />
          )}
          {facets.users.length > 0 && (
            <FilterSelect label="User" value={filters.user} onChange={filterBy('user')} options={withAnyOption('Any user', facets.users)} />
          )}
          {facets.models.length > 0 && (
            <FilterSelect label="Model" value={filters.model} onChange={filterBy('model')} options={withAnyOption('Any model', facets.models)} />
          )}
        </FilterSection>
      )}

      <FilterSection title="Date range">
        <DateInput label="From" value={filters.date_from} onChange={filterBy('date_from')} />
        <DateInput label="To" value={filters.date_to} onChange={filterBy('date_to')} />
      </FilterSection>
    </>
  );
};

export default SessionFilters;
